export default __webpack_public_path__ + "static/media/cs.94227672.jpg";